import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { leaveChannel } from '../api/client.js';
import { partyViewQueryKey } from '../api/queryKeys.js';

import { useMyPartyInvalidation } from './useMyPartyInvalidation.js';

import type { ChannelId, PartySlug, PartyView } from '@mixwire/contracts';

type LeaveVariables = {
  readonly slug: PartySlug;
  readonly channelId: ChannelId;
};

// A real server action, not just a navigation: it frees the slot and releases the shared Spotify poll held for this DJ.
export const useLeaveChannel = (): UseMutationResult<PartyView, Error, LeaveVariables> => {
  const queryClient = useQueryClient();
  const invalidateMyParty = useMyPartyInvalidation();

  return useMutation({
    mutationFn: async ({ slug, channelId }: LeaveVariables) => leaveChannel(slug, channelId),
    onSuccess: (party) => {
      queryClient.setQueryData<PartyView>(partyViewQueryKey(party.slug), party);
      invalidateMyParty();
    },
  });
};
